// extracted by mini-css-extract-plugin
export var capitalize = "CustomService-mps-module--capitalize--616c8";
export var formFields = "CustomService-mps-module--formFields--a42d5";
export var root = "CustomService-mps-module--root--04950";
export var select = "CustomService-mps-module--select--3ea4e";